import request from '../request';

const sanitizeParams = (params = {}) => {
  const result = { ...params };
  if (Object.prototype.hasOwnProperty.call(result, 'search')) {
    const searchValue =
      result.search === undefined || result.search === null
        ? ''
        : String(result.search).trim();
    if (!searchValue) {
      delete result.search;
    } else {
      result.search = searchValue;
    }
  }
  return result;
};

const productService = {
  getAll: (params) =>
    request.get('rest/products/paginate', { params: sanitizeParams(params) }),
  getProductByIds: (params) =>
    request.get('rest/products/ids', { params: sanitizeParams(params) }),
  getByID: (id, params) => request.get(`rest/products/${id}`, { params }),
  search: (params) =>
    request.get('rest/products/paginate', { params: sanitizeParams(params) }),
};

export default productService;
